import { useCallback, useEffect, useState } from 'react';

type UseAsyncToggleProps = {
  syncedValue: boolean;
  onUpdate: (nextValue: boolean) => Promise<void>;
};

export default function useAsyncToggle({ syncedValue, onUpdate }: UseAsyncToggleProps) {
  const [value, setValue] = useState(syncedValue);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    setValue(syncedValue);
  }, [syncedValue]);

  const toggle = useCallback(async () => {
    if (isUpdating) {
      return;
    }

    const nextValue = !value;
    setIsUpdating(true);

    try {
      await onUpdate(nextValue);
      setValue(nextValue);
    } finally {
      setIsUpdating(false);
    }
  }, [isUpdating, onUpdate, value]);

  return {
    value,
    isUpdating,
    toggle,
  };
}
